export default {
  path: 'individual',
  component: () => import( /* webpackChunkName: "individual-list" */ '@/pages/individual/List'),
  meta: {
    title: '集群注册记录'
  },
  children: [{
    path: ':individual_id/view',
    component: () => import( /* webpackChunkName: "individual-view" */ '@/pages/individual/CreateEdit'),
    meta: {
      title: '查看个体户注册'
    },
  }]
}